import { gql } from "@apollo/client";

const GET_INCOMPLETE_DEDUCTION_RESOLUTION_STATUS = gql`
  query GetIncompleteDeductionResolutionStatus($params: GetDeductionResolutionStatusParams!) {
    deductionResolutionStatus(params: $params) {
      remittanceItemId
      documents {
        id
        fileName
        fileSize
        createdAt
        updatedAt
        documentType
        fileMimeType
        fileDisplayName
        filePath
        deletable
        isProcessed
      }
      purchaserKey
    }
  }
`;

export default GET_INCOMPLETE_DEDUCTION_RESOLUTION_STATUS;
